import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "sonner";
import { ThemeProvider } from "styled-components";
import { routeTree } from "./routeTree.gen";
import { theme } from "./theme";
import "./theme/main.css";

Sentry.init({
	dsn: "SENTRY_DSN_HERE",
	integrations: [],
	enabled: import.meta.env.PROD,
});

const queryClient = new QueryClient();

const router = createRouter({
	routeTree,
	context: {
		queryClient,
	},
	defaultPreload: "intent",
	defaultPreloadStaleTime: 0,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

const rootElement = document.getElementById("root");
if (rootElement && !rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement);
	root.render(
		<StrictMode>
			<QueryClientProvider client={queryClient}>
				<ThemeProvider theme={theme}>
					<RouterProvider router={router} />
				</ThemeProvider>
				<Toaster richColors closeButton className="sonner-toast" />
			</QueryClientProvider>
		</StrictMode>
	);
}

if (import.meta.env.PROD) {
	console.log(`Looking under the hood? Interested in our work or a job?
		Contact us via https://3dconfig.com
		 _____ ____     ____ ___  _   _ _____ ___ ____ 
		|___ /|  _ \\   / ___/ _ \\| \\ | |  ___|_ _/ ___|
		  |_ \\| | | | | |  | | | |  \\| | |_   | | |  _ 
		 ___) | |_| | | |__| |_| | |\\  |  _|  | | |_| |
		|____/|____/   \\____\\___/|_| \\_|_|   |___\\____|
		`);
}
